/**
 * /dashboard entrypoint.
 *
 * Two jobs since the 2026-08-27 redesign:
 *  1. Keep the legacy deep-link contract: email and SMS CTAs link to
 *     /dashboard?case=<bill_id>, and those still forward to /case/:id.
 *  2. Everything else renders the case-first Home. Before this,
 *     /dashboard bounced to the customer's most recent case, which
 *     meant nobody ever saw their cases in one place.
 *
 * The old chat-first Dashboard.tsx remains in the tree, unrouted, as a
 * rollback path.
 */

import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import AppSidebar from '../components/AppSidebar';
import Home from './Home';

export default function DashboardRedirect() {
  const navigate = useNavigate();
  const { user, loading: authLoading } = useAuth();
  const [params] = useSearchParams();
  const fromQuery = params.get('case');

  useEffect(() => {
    if (authLoading) return;
    if (!user) {
      navigate('/login', { replace: true });
      return;
    }
    if (fromQuery) {
      navigate(`/case/${fromQuery}`, { replace: true });
    }
  }, [user, authLoading, navigate, fromQuery]);

  if (fromQuery || authLoading || !user) {
    /* Brief skeleton while auth resolves or the deep link forwards.
       Wrapped in AppSidebar so the chrome doesn't flash on/off. */
    return (
      <AppSidebar>
        <div
          style={{
            padding: '64px 24px',
            textAlign: 'center',
            color: 'var(--color-text-muted)',
            fontSize: 14,
          }}
          aria-busy="true"
        >
          Opening your cases…
        </div>
      </AppSidebar>
    );
  }

  return (
    <AppSidebar>
      <Home />
    </AppSidebar>
  );
}
